import { Component, OnInit } from '@angular/core';
import { RegionService } from '../../regions/region.service';
import { CityService } from '../city.service';
import { City } from '../city';
import { Message } from 'primeng/primeng';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-city',
  templateUrl: './city.component.html',
  styleUrls: ['./city.component.css'],
  providers: [
    RegionService,
    CityService
   ]
})
export class CityComponent implements OnInit {

  id: null;  
  loading: boolean;
  loadingDialog: boolean;
  msgs: Message[] = [];
  display: boolean=false;
  city: City;
  cities: string[];
  selectedRegion: string;
  button_caption: string ="Сохранить"
  button_icon:string ="fa fa-save";
  eventType: string;

  constructor(
    private regionService: RegionService,
    private cityService: CityService
   ) { }

  ngOnInit() {
    this.city = {
      name: "",
      regions: [],
      available: true
    };

    this.loadCities();

    this.regionService.getRegion().subscribe(response=>{this.city.regions=response['data'].map(function(value: any){
      return {label:value.name, value: value.id};
    });});

  }

  loadCities(){
    this.loading = true;
    this.cityService.getCity().subscribe(response=> {this.cities=response['data']; ;this.loading = false;});
  }

  reset(){
    this.selectedRegion = this.city.regions[0];
    this.city.name = "";
  }  

  onAdd(){
    this.reset();
    this.eventType = "add";
    this.button_caption = "Сохранить";
    this.button_icon = "fa fa-save";
    this.display = true;
  }

  onEdit(id: any){
    this.reset();
    this.display = true;
    this.id= id;
    this.loadingDialog=true;
    this.eventType = "edit";
    this.button_caption = "Редактировать";
    this.button_icon = "fa fa-edit";
    this.cityService.getCityById(id).subscribe(response=>{
      this.city = response['data'];
      this.regionService.getRegion().subscribe(response=>{this.city.regions=response['data'].map(function(value: any){
        return {label:value.name, value: value.id};
      });
      this.loadingDialog=false;
      });
      this.selectedRegion=response['data'].region.id;
    });
  
 
  }


  crud(form: NgForm):void{
    if( this.eventType == "add"){
        this.loadingDialog=true;
        this.cityService.createCity(form.value)
        .subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно добавлено"});this.loadingDialog=false; this.display = false;this.loadCities(); }
             , (error)=>{
                                let str="";
                                  this.loading=false; 
                                  for (let item in error.error.errors) {
                                        str+="\n" +error.error.errors[item][0];
                                  }
                                  this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});
                          });

    }else{
      this.loadingDialog=true;
      this.cityService.updateCity(form.value,this.id)
        .subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно изменено"});this.loadingDialog=false; this.display = false;this.loadCities(); }
             , (error)=>{
                             let str="";
                                  this.loading=false; 
                                  for (let item in error.error.errors) {
                                        str+="\n" +error.error.errors[item][0];
                                  }
                                  this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});
                          });
    }
}

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/cities/city/city.component.ts